import getNewReport from '../api/newReport'
import getReport from '../api/getReport'
import Report from '../common/types/api/report'

export const actionUpdateReport = async (uid: string): Promise<Report> => {
    if (uid === 'new') {
        const newReport = await getNewReport()        
        if (newReport) {
            return newReport.config
        }
        throw new Error('API ERROR: NEW REPORT')
    } else {
        const reportLoaded = await getReport(uid)

        if (reportLoaded) {
            return reportLoaded
        }
        throw new Error('API ERROR: GET REPORT')
    }
}